import { ROW_DATA_KEYS } from "../../../pages/LandingPage/constants";
import {
  JsonSchemaProperty,
  RowDataObject,
  JsonSchemaItems,
  RowData,
  RowDataReducerState,
  RowDataReducerActionPayload,
} from "../../../types";

export const addObjectRowAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
  property: JsonSchemaProperty,
): RowDataReducerState => {
  const { propertyKey, selectedTabSectionKey } = payload;
  if (!propertyKey || !property) return state;

  if (selectedTabSectionKey) {
    return addNestedObjectRow(
      propertyKey,
      property,
      selectedTabSectionKey,
      state,
    );
  }

  return addObjectRow(propertyKey, property, state);
};

const addNestedObjectRow = (
  propertyKey: string,
  property: JsonSchemaProperty,
  selectedTabSectionKey: string,
  state: RowDataReducerState,
): RowDataReducerState => {
  const currentArray =
    ((state.rowData[selectedTabSectionKey] as RowData)?.[
      propertyKey
    ] as RowDataObject[]) ?? [];
  const items = property.items as JsonSchemaItems;

  const newItem: RowDataObject = Object.keys(items?.properties || {}).reduce(
    (acc, key) => ({
      ...acc,
      [key]: items?.properties?.[key]?.default ?? "",
    }),
    { [ROW_DATA_KEYS.ACTIVE_STATUS]: "active" } as RowDataObject,
  );

  const updatedRowData = {
    ...state.rowData,
    [selectedTabSectionKey]: {
      ...(state.rowData[selectedTabSectionKey] as RowData),
      [propertyKey]: [...currentArray, newItem],
    },
  } as RowData;

  return {
    ...state,
    rowData: updatedRowData,
  };
};

const addObjectRow = (
  propertyKey: string,
  property: JsonSchemaProperty,
  state: RowDataReducerState,
): RowDataReducerState => {
  const currentArray = (state.rowData[propertyKey] as RowDataObject[]) ?? [];
  const items = property.items as JsonSchemaItems;

  const newItem: RowDataObject = Object.keys(items?.properties || {}).reduce(
    (acc, key) => ({
      ...acc,
      [key]: items?.properties?.[key]?.default ?? "",
    }),
    { [ROW_DATA_KEYS.ACTIVE_STATUS]: "active" } as RowDataObject,
  );

  const updatedRowData = {
    ...state.rowData,
    [propertyKey]: [...currentArray, newItem],
  } as RowData;

  return {
    ...state,
    rowData: updatedRowData,
  };
};
